import { createContext, useContext, useEffect, useState } from "react";
import { Filter, useFilter } from "../common/filter";
import { Search, useSearch } from "../common/search";
import { useOrder } from "./order";


export const UNIT_CATEGORIES = {
    'swarm': 'Sciame',
    'monster': 'Mostro',
    'vehicle': 'Veicolo',
    'infantry': 'Fanteria',
    'mounted': 'A cavallo',
    'titanic': 'Titanico',
    'walker': 'Camminatore',
    'character': 'Personaggio',
    'epic_hero': 'Epico',
    'psyker': 'Psichico',
}

export const UNIT_GRADES = [
    'hero',
    'legendary',
    'heroic',
    'battleh',
    'blooded',
    'bready',
]

export function UNIT_NAME(u) {
    return u.name || u.unitType
}

export function UNIT_SORT(u1, u2) {
    return UNIT_GRADES.indexOf(u1.grade) - UNIT_GRADES.indexOf(u2.grade)
        || Math.max(u2.xp, 0) - Math.max(u1.xp, 0)
        || u2.played - u1.played
        || u2.xp - u1.xp
        || UNIT_NAME(u1).localeCompare(UNIT_NAME(u2))

}

export function UNIT_XP_PERC(xp) {
    var min = 0;
    var max = 5;

    if (xp < 0) {
        return 0;
    }
    if (xp > 5) {
        min = 6;
        max = 15;
    }
    if (xp > 15) {
        min = 16;
        max = 30;
    }
    if (xp > 30) {
        min = 31;
        max = 50;
    }
    if (xp > 50) {
        return 0;
    }


    const perc = ((xp - min) * 100) / (max - min);
    return perc;
}

const UnitContext = createContext();
export function Unit(props) {
    const { id } = props;
    const order = useOrder()
    const unit = order.units.filter(u => u.id === id)[0];

    return <UnitContext.Provider
        value={{
            unit,
            reload: order.reload,
            call: order.call,
        }}
        {...props}
    />
}

export function useUnit() {
    const { unit, reload, call } = useContext(UnitContext)

    function removeEnhancement() {
        call('unit/' + unit.id + '/enhancement/remove')
    }
    const gainXp = unit.xp >= 0;
    const isEpic = unit.grade === 'epic';
    const isNew = unit.xp == 0 && unit.played == 0;

    return {
        ...unit,
        viewEnhancements: Boolean(unit.enhancements),
        isEpic,
        isChar: unit.categories.includes('character') || isEpic,
        gainXp,
        hasCategory: (c) => unit.categories.includes(c),
        viewEquipments: !isEpic,
        reload,
        isNew,

        removeEnhancement,
    }
}